import $ from 'jquery'

export default () => {
    let section = $('.text-page');
    let containerText = section.find('.content');
    let table = containerText.find('table');
    if (table.length) {
        table.wrap('<div class="table-responsive"></div>');
        table.addClass('table');
    }
}
